export default "/assets/images/critter-cuddler-crop.9fc905068ad3709c.png";